import { ThemeProvider, unstable_createMuiStrictModeTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export function ProvideTheme({ children }: PropsWithChildren<{}>) {
    const theme = unstable_createMuiStrictModeTheme({
        palette: {
            primary: {
                main: '#00446A',
                light: '#406F98',
                dark: '#001E3F',
            },
            secondary: {
                main: '#F08B1D',
                light: '#FFBC51',
                dark: '#B85D00',
            },
        },
        typography: {
            htmlFontSize: 14,
        },
    });
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
